<template>
  <div class="welcome">
    <!-- 搜索 -->
    <div class="sticky_top">
      <div class="header_bgColor"></div>
      <div class="header_input size15 overflow">
        <div class="fl" @click="toSearch" style="width: 100%">
          <van-icon name="search" />
          搜索政策...
        </div>
        <!-- <img class="fr header_pic" src="../images/bronze.png" alt="" /> -->
      </div>
    </div>
    <!-- 列表 -->
    <div class="p15">
      <div
        :class="[item.borderClz, 'list']"
        @click="toNext(item.id)"
        :style="{ background: item.bg, backgroundSize: '100%' }"
        v-for="(item, index) in cardList"
        :key="index"
      >
        <div class="overflow">
          <img class="icon fl" :src="item.icon" alt="" />
          <div class="title fl">{{ item.title }}</div>
        </div>
        <div class="content">{{ item.content }}</div>
        <div class="overflow mt5">
          <div class="fl watch">查看</div>
          <img class="fl" :src="item.rightIcon" alt="" />
        </div>
        <img :class="'tip_pic_' + index" :src="item.personIcon" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cardList: [
        {
          id: 1,
          bg: "url('https://dev-api.leyanbot.com/wsk/talent/upload/mini/bgOne.png')",
          icon: require("../images/welcome/iconOne.png"),
          personIcon: require("../images/welcome/personOne.png"),
          rightIcon: require("../images/welcome/rightOne.svg"),
          title: "智能匹配",
          content: "根据您的信息，个性化匹配适合您的政策",
          borderClz: "borderColorOne",
        },
        {
          id: 2,
          bg: "url('https://dev-api.leyanbot.com/wsk/talent/upload/mini/bgTwo.png')",
          icon: require("../images/welcome/iconTwo.png"),
          personIcon: require("../images/welcome/personTwo.png"),
          rightIcon: require("../images/welcome/rightTwo.svg"),
          title: "人才政策",
          content: "长宁区和上海市的各类人才政策，政策申请条件在线预评估",
          borderClz: "borderColorTwo",
        },
        // {
        //   id: 3,
        //   bg: "url('https://dev-api.leyanbot.com/wsk/talent/upload/mini/bgFour.png')",
        //   icon: require("../images/welcome/iconFour.svg"),
        //   personIcon: require("../images/welcome/personFour.png"),
        //   rightIcon: require("../images/welcome/rightFour.svg"),
        //   title: "意见反馈",
        //   content:
        //     "您在使用过程中有任何问题或建议，可进行在线反馈，感谢您的宝贵建议",
        //   borderClz: "borderColorThree",
        // },
        // {
        //   id: 4,
        //   bg: "url('https://dev-api.leyanbot.com/wsk/talent/upload/mini/bgThree.png')",
        //   icon: require("../images/welcome/iconThree.png"),
        //   personIcon: require("../images/welcome/personThree.png"),
        //   rightIcon: require("../images/welcome/rightThree.svg"),
        //   title: "数据统计",
        //   content:
        //     "查看长宁人才通数据统计，了解政策文章阅读量及政策测评数量统计",
        //   borderClz: "borderColorFour",
        // },
      ],
    };
  },
  methods: {
    toSearch() {
      this.$router.push("/search");
    },
    toNext(id) {
      switch (id) {
        case 1:
          this.$router.push("/addlabel");
          break;
        case 2:
          this.$router.push("/policyList");
          break;
        default:
          break;
      }
    },
  },
  created() {},
};
</script>

<style scoped lang="less">
.welcome {
  padding-top: 45px;
  // background: #4b6fde;
  min-height: 100vh;
  box-sizing: border-box;
  .sticky_top {
    position: fixed;
    left: 0px;
    right: 0px;
    top: 0px;
    z-index: 2;
  }
  .header_bgColor {
    background: #6d90e2;
    height: 40px;
    border-radius: 0 0 25px 25px;
  }
  .header_input {
    height: 40px;
    line-height: 40px;
    background-color: #ffffff;
    box-shadow: 0px 4px 4px 0px rgba(210, 213, 217, 0.13);
    border-radius: 4px;
    border: 1px solid #e1e4eb;
    padding-left: 11px;
    color: #d2d5d9;
    margin: -20px 15px 0 15px;
  }
  .header_pic {
    width: 32px;
    height: 32px;
    margin: 4px 3px 0 0;
  }
  .list {
    height: 180px;
    border-radius: 16px;
    margin-top: 16px;
    padding: 22px 0 0 12px;
    box-sizing: border-box;
    position: relative;
    .tip_pic_0 {
      position: absolute;
      right: 10px;
      top: 15px;
      width: 140px;
      height: 156px;
    }
    .tip_pic_1 {
      position: absolute;
      right: 10px;
      top: 15px;
      width: 140px;
      height: 156px;
    }
    .tip_pic_2 {
      position: absolute;
      right: 4px;
      top: 35px;
      width: 145px;
      height: 138px;
    }
    .icon {
      width: 24px;
      height: 24px;
    }
    .title {
      height: 27px;
      font-size: 20px;
      color: #4d0f0f;
      line-height: 24px;
      margin-left: 6px;
      font-weight: 600;
    }
    .content {

      height: 66px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      font-size: 16px;
      font-weight: 400;
      color: #4d3a3a;
      line-height: 22px;
      margin-top: 6px;
      margin-right: 140px;
    }
  }
  .borderColorOne {
    border: 1px solid #ebdbdb;
    background-color: #fceeed!important;
    .title {
      color: #4d0f0f;
    }
    .content {
      color: #4d3a3a;
    }
  }
  .borderColorOne .watch {
    font-size: 15px;
    margin-right: 5px;
    color: #f05b5b;
    line-height: 18px;
  }
  .borderColorTwo {
    border: 1px solid #d8eaea;
    background-color: #e6f3f3!important;
    .title {
      color: #0b4d4b;
    }
    .content {
      color: #2e4d4c;
    }
  }

  .borderColorTwo .watch {
    font-size: 15px;
    margin-right: 5px;
    color: #00bf69;
    line-height: 18px;
  }

  .borderColorThree {
    border: 1px solid #e0d6e8;
    .title {
      color: #07228c;
    }
    .content {
      color: #273159;
    }
  }
  .borderColorThree .watch {
    font-size: 15px;
    margin-right: 5px;
    color: #3370ff;
    line-height: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/welcome.vue